export const IS_SHOP_POPUP_OPENED_IN_SESSION =
	"is_shop_popup_opened_in_session";

export const SPECIAL_BUILDING_PACK_COOLDOWN_TIME =
	"special_building_pack_cooldown_time";

export const EVENT_POPUP_SHOWN_COOLDOWN = "event_popup_shown_cooldown";

export const setWithExpiry = (key: string, ttl: number): void => {
	const item = {
		value: key,
		expiry: Date.now() + ttl,
	};
	localStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = <T = unknown>(key: string): T | null => {
	const itemStr = localStorage.getItem(key);
	if (!itemStr) return null;

	try {
		const item = JSON.parse(itemStr) as { value: T; expiry: number };
		if (!Number.isFinite(item?.expiry)) {
			localStorage.removeItem(key);
			return null;
		}
		if (Date.now() > (item.expiry ?? 0)) {
			localStorage.removeItem(key);
			return null;
		}
		return item.value;
	} catch {
		localStorage.removeItem(key);
		return null;
	}
};
